<template>
  <div class="page-component-wrapper">
    <grid :config="gridConfig"/>
    <modal-new :config="{id: gridConfig.id, api: 'Vats/Get/'}"/>
  </div>
</template>

<script>
import { GridConfig } from './GridConfig'
import { vatsWithDisabled } from '@/utils/shared'

export default {
  name: 'VTSsIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'modal-new': () => import(/* webpackChunkName: 'VATs' */ './ModalNew')
  },
  data () {
    const gridConfig = GridConfig({ parser: this.parser })
    return {
      gridConfig: gridConfig
    }
  },
  methods: {
    parser (list) {
      return vatsWithDisabled(list).filter((item) => {
        return !item.disabled
      })
    }
  }
}
</script>
